import { put, call, all, takeLatest, select } from "redux-saga/effects";
import {
  REQPushNotiList,
  RESPushNotiList,
  FailPushNotiList,
  DELPushNotiCampaign
} from "./actions";
import * as actions from "../../Authentication/redux/actions";
import { readCampaigns, removeCampaign } from "../history";
import { PUSH_HISTORY_URL } from "../../PushNotiCompose/config";

/*
 * Campaign history: the browser copy is always read.
 * With REACT_APP_API_PUSH_HISTORY_URL set, the backend list is fetched and merged in.
 */
function* fetchPushNotiListWorker() {
  const local = yield call(readCampaigns);

  if (!PUSH_HISTORY_URL) {
    yield put(RESPushNotiList({ campaigns: local, remoteAvailable: false }));
    return;
  }

  try {
    const accessToken = yield select(state => state.auth.accessToken);
    const tGUID = yield select(state => state.auth.GUID);
    const request = yield fetch(PUSH_HISTORY_URL, {
      method: "GET",
      headers: {
        userid: tGUID,
        "x-id-token": "Bearer " + accessToken
      }
    });

    if (request.status === 401) {
      yield put(actions.autoSignOut());
      return;
    }

    if (!request.ok) {
      yield put(RESPushNotiList({ campaigns: local, remoteAvailable: false }));
      return;
    }

    const response = yield request.json();
    const remote = Array.isArray(response) ? response : response.data || [];
    const remoteIds = remote.map(item => item.id);

    yield put(
      RESPushNotiList({
        campaigns: [...remote, ...local.filter(item => !remoteIds.includes(item.id))],
        remoteAvailable: true
      })
    );
  } catch (error) {
    yield put(RESPushNotiList({ campaigns: local, remoteAvailable: false }));
  }
}

function* deletePushNotiCampaignWorker({ payload }) {
  try {
    yield call(removeCampaign, payload);
    yield call(fetchPushNotiListWorker);
  } catch (error) {
    yield put(FailPushNotiList({ message: error.message }));
  }
}

export function* pushNotiListSaga() {
  yield all([
    takeLatest(REQPushNotiList, fetchPushNotiListWorker),
    takeLatest(DELPushNotiCampaign, deletePushNotiCampaignWorker)
  ]);
}
